import { AdvertCapability } from '../__generated__/graphql-types';
/**
 * Taking an array of strings, digital retailing values, map these to capability values that GraphQL accepts
 */
export function mapGPXToAdvertQueryCapabilities(storage) {
    const advertQueryCapabilities = [];
    storage.forEach((param) => {
        if (param === 'GPX') {
            advertQueryCapabilities.push(AdvertCapability.GUARANTEED_PART_EX);
        }
    });
    return advertQueryCapabilities;
}
/**
 * Taking the advert query, map capability values to search local storage values
 */
export function mapAdvertQueryCapabilitiesToStorage(advertQuery) {
    var _a, _b;
    let mappedQuery = Object.assign(Object.assign({}, advertQuery), { digitalRetailing: [], capabilities: [] });
    if (advertQuery.capabilities && ((_a = advertQuery.capabilities) === null || _a === void 0 ? void 0 : _a.length)) {
        (_b = advertQuery.capabilities) === null || _b === void 0 ? void 0 : _b.forEach((capability) => {
            var _a;
            if (capability === AdvertCapability.GUARANTEED_PART_EX) {
                ;
                (_a = mappedQuery.digitalRetailing) === null || _a === void 0 ? void 0 : _a.push('GPX');
            }
        });
    }
    else {
        mappedQuery.capabilities = undefined;
        mappedQuery.digitalRetailing = undefined;
    }
    return mappedQuery;
}
